import { Radio } from 'antd';

import { DISABLE_TYPE_KEYS, FILTER_DATA_OPTIONS } from './constants';

/**
 * Radio group for filtering by schedule type.
 *
 * @param {Object} props
 * @param {Function} [props.onChange] - Callback when selection changes
 * @param {string|null} [props.value] - Currently selected value
 * @param {Object} [props.disabledTypes] - Schedule types to disable
 * @param {boolean} [props.disabledTypes.null] - Disables "All" option
 * @param {boolean} [props.disabledTypes.tasks] - Disables "Tasks" option
 * @param {boolean} [props.disabledTypes.schedules] - Disables "Schedules" option
 * @param {boolean} [props.disabledTypes.checkpoint_route] - Disables "Checkpoint Route" option
 * @returns {React.ReactNode}
 */
export const FilterData = ({
  onChange,
  value,
  disabledTypes,
  filterDataOptions = [],
  ...props
}) => {
  const options = filterDataOptions.length > 0 ? filterDataOptions : FILTER_DATA_OPTIONS;
  return (
    <Radio.Group onChange={onChange} value={value} {...props}>
      {options.map(option => (
        <Radio
          key={option.value}
          value={option.value}
          checked={value === option.value}
          disabled={disabledTypes && disabledTypes[DISABLE_TYPE_KEYS[option.value]]}
        >
          {option.label}
        </Radio>
      ))}
    </Radio.Group>
  );
};
